import './js/openFooterMdl';
import './js/localStorage';
import { renderLibraryGallery } from './js/renderGallery';
import { modalFunctions } from './js/userLogin';
import { openMovieInfoModalLibrary } from './js/openMovieInfoModalLibrary';

modalFunctions();
renderLibraryGallery();
openMovieInfoModalLibrary();
